import {
  experiences_per_week,
  fitness_experiences,
  gender,
  memberGoals,
  pt_trial_focus,
  type_of_exercise,
} from "../../common-data/DropdowData";

export const validateTMEForm = (formValues, isEdit) => {
  let errors = {};
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const mobileRegex = /^\d{10}$/;
  const yopmailDomains = [
    "yopmail.com",
    "yopmail.net",
    "yopmail.fr",
    "yopmail.org",
  ];

  if (!formValues.trainerName) {
    errors.trainerName = "Trainer Name Required!";
  }

  if (!formValues.trainerMobile) {
    errors.trainerMobile = "Trainer Number Required!";
  } else if (!mobileRegex.test(formValues.trainerMobile)) {
    errors.trainerMobile = "invalid trainer mobile number!";
  }

  if (formValues.trainerEmail && !emailRegex.test(formValues.trainerEmail)) {
    errors.trainerEmail = "invalid Trainer Email Required!";
  } else if (
    formValues.trainerEmail &&
    yopmailDomains.some((domain) => formValues.trainerEmail.includes(domain))
  ) {
    errors.trainerEmail = "Yopmail email addresses are not allowed!";
  }

  if (!formValues.selectedGym) {
    errors.selectedGym = "GYm Name Required!";
  }

  if (!formValues.memberName) {
    errors.memberName = "Member Name Name Required!";
  }

  if (!formValues.memberMobile) {
    errors.memberMobile = "Member Number Required!";
  } else if (!mobileRegex.test(formValues.memberMobile)) {
    errors.memberMobile = "invalid mobile number!";
  } else if (
    formValues.memberMobile &&
    yopmailDomains.some((domain) => formValues.memberMobile.includes(domain))
  ) {
    errors.memberMobile = "Yopmail email addresses are not allowed!";
  }

  if (!formValues.selectedGender?.value) {
    errors.selectedGender = "Member Gender Required!";
  }

  if (!formValues.selectedExerciseDuration) {
    errors.selectedExerciseDuration = "member exercise per week  Required!";
  }

  if (!formValues.selectedFitnessExp) {
    errors.selectedFitnessExp = "member Fitness Experience Required!";
  }

  if (formValues.selectedUserGoals?.length === 0) {
    errors.selectedUserGoals = "Member  Fitness Goal Required!";
  }

  if (
    formValues.selectedUserGoals?.length > 0 &&
    formValues.selectedUserGoals?.some((goal) => goal.value === "other") &&
    !formValues.otherMemberFitnessGoal
  ) {
    errors.otherMemberFitnessGoal = "Member  Fitness Goal Required!";
  }

  if (formValues.selectedTypeOfExercise?.length === 0) {
    errors.selectedTypeOfExercise = "Member  Fitness Goal Required!";
  }

  if (
    formValues.selectedTypeOfExercise?.length > 0 &&
    formValues.selectedTypeOfExercise?.some((goal) => goal.value === "other") &&
    !formValues.otherTypeOfExercise
  ) {
    errors.otherTypeOfExercise = "Member  Fitness Goal Required!";
  }

  if (formValues.isInterestedForPT && !formValues.ptTrailDate) {
    errors.ptTrailDate = "PT Trial Date Required!";
  }

  // if (formValues.isInterestedForPT && !formValues.selectedSlot) {
  //   errors.selectedSlot = "Slot For PT Trial Required!";
  // }

  if (!formValues.isInterestedForPT && !formValues.notPtReason) {
    errors.notPtReason =
      "Member reason of not taking a Free PT Consultation Required!";
  }

  if (
    formValues.isInterestedForPT &&
    formValues.selectedPTTrialFocus?.length === 0
  ) {
    errors.selectedPTTrialFocus = "Member  Fitness Goal Required!";
  }

  if (
    formValues.isInterestedForPT &&
    formValues.selectedPTTrialFocus?.length > 0 &&
    formValues.selectedPTTrialFocus?.some((goal) => goal.value === "other") &&
    !formValues.otherPTTrialFocus
  ) {
    errors.otherPTTrialFocus = "Member  Fitness Goal Required!";
  }

  // if (!isEdit && !formValues.bcaFile) {
  //   errors.bcaFile = "BCA Report Required!";
  // }

  return errors;
};

export const matchGenderFun = (genders) => {
  return gender?.find((option) => option?.value === genders);
};

export const matchGoalFun = (fitness_goal) => {
  const fitnessGoalsArray = fitness_goal
    ? fitness_goal
        ?.split(",")
        ?.map((goal) => goal?.trim())
        ?.filter((goal) => goal !== "false" && goal)
    : [];
  const matchedGoals = memberGoals?.filter((goal) =>
    fitnessGoalsArray?.includes(goal.value)
  );
  const nonMatchingGoals = fitnessGoalsArray?.filter(
    (goal) =>
      goal && !memberGoals?.some((memberGoal) => memberGoal.value === goal)
  );
  if (nonMatchingGoals.length > 0) {
    matchedGoals.push({
      value: "other",
      label: "Other",
    });
  }
  return matchedGoals;
};

export const matchOtherGoalFun = (fitness_goal) => {
  const fitnessGoalsArray = fitness_goal
    ? fitness_goal
        ?.split(",")
        ?.map((goal) => goal?.trim())
        ?.filter((goal) => goal !== "false" && goal)
    : [];
  const matchedGoals = memberGoals?.filter((goal) =>
    fitnessGoalsArray?.includes(goal.value)
  );
  const nonMatchingGoals = fitnessGoalsArray?.filter(
    (goal) =>
      goal && !memberGoals?.some((memberGoal) => memberGoal.value === goal)
  );
  if (nonMatchingGoals.length > 0) {
    matchedGoals.push({
      value: "other",
      label: "Other",
    });
  }
  const otherMemberFitnessGoal =
    nonMatchingGoals.length > 0 ? nonMatchingGoals?.join(", ") : "";
  return otherMemberFitnessGoal;
};

export const matchFitnessExperienceFun = (fitness_experience) => {
  return fitness_experiences?.find(
    (option) => option.value === fitness_experience
  );
};

export const matchExerciseDurationFun = (durations) => {
  const matchedExerciseDuration = experiences_per_week?.find(
    (option) => option.value === durations
  );
  return matchedExerciseDuration;
};

export const matchExercisesFun = (exercise_type) => {
  const typeOfExerciseArray = exercise_type
    ? exercise_type
        ?.split(",")
        ?.map((goal) => goal.trim())
        ?.filter((goal) => goal !== "false" && goal)
    : [];
  const matchedTypeOfExercise = type_of_exercise?.filter((exercise) =>
    typeOfExerciseArray?.includes(exercise.value)
  );
  const nonMatchingTypeOfExercise = typeOfExerciseArray?.filter(
    (exercise) => !type_of_exercise?.some((type) => type.value === exercise)
  );
  if (nonMatchingTypeOfExercise.length > 0) {
    matchedTypeOfExercise.push({
      value: "other",
      label: "Other",
    });
  }
  return matchedTypeOfExercise;
};

export const matchOtherExerciseFun = (exercise_type) => {
  const typeOfExerciseArray = exercise_type
    ? exercise_type
        ?.split(",")
        ?.map((goal) => goal.trim())
        ?.filter((goal) => goal !== "false" && goal)
    : [];
  const matchedTypeOfExercise = type_of_exercise?.filter((exercise) =>
    typeOfExerciseArray?.includes(exercise.value)
  );
  const nonMatchingTypeOfExercise = typeOfExerciseArray?.filter(
    (exercise) => !type_of_exercise?.some((type) => type.value === exercise)
  );
  if (nonMatchingTypeOfExercise.length > 0) {
    matchedTypeOfExercise.push({
      value: "other",
      label: "Other",
    });
  }
  const otherTypeOfExercise =
    nonMatchingTypeOfExercise.length > 0
      ? nonMatchingTypeOfExercise?.join(", ")
      : "";

  return otherTypeOfExercise;
};

export const matchPTTrialFocusFun = (consultation_focus_on) => {
  const ptTrialFocusArray = consultation_focus_on
    ? consultation_focus_on
        ?.split(",")
        ?.map((goal) => goal?.trim())
        ?.filter((goal) => goal !== "false" && goal)
    : [];

  const matchedPtTrialFocus = pt_trial_focus?.filter((goal) =>
    ptTrialFocusArray?.includes(goal.value)
  );

  const nonMatchingPtTrialFocus = ptTrialFocusArray?.filter(
    (goal) => !pt_trial_focus?.some((memberGoal) => memberGoal.value === goal)
  );

  if (nonMatchingPtTrialFocus.length > 0) {
    matchedPtTrialFocus.push({
      value: "other",
      label: "Other",
    });
  }

  return matchedPtTrialFocus;
};

export const matchOtherPTTrialFocusFun = (consultation_focus_on) => {
  const ptTrialFocusArray = consultation_focus_on
    ? consultation_focus_on
        ?.split(",")
        ?.map((goal) => goal?.trim())
        ?.filter((goal) => goal !== "false" && goal)
    : [];

  const matchedPtTrialFocus = pt_trial_focus?.filter((goal) =>
    ptTrialFocusArray?.includes(goal.value)
  );

  const nonMatchingPtTrialFocus = ptTrialFocusArray?.filter(
    (goal) => !pt_trial_focus?.some((memberGoal) => memberGoal.value === goal)
  );

  if (nonMatchingPtTrialFocus.length > 0) {
    matchedPtTrialFocus.push({
      value: "other",
      label: "Other",
    });
  }

  const otherPTTrialFocus =
    nonMatchingPtTrialFocus.length > 0
      ? nonMatchingPtTrialFocus?.join(", ")
      : "";

  return otherPTTrialFocus;
};
